var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayDowndropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M0 0h15v15H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    fillRule: "evenodd",
    d: "M7.501 12.001L0 4.001h15.002l-7.501 8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayDowndropIcon);
export default __webpack_public_path__ + "static/media/gray-downdrop-icon.6cc19bd2e1c64eb9a1b41f44bf42fe25.svg";
export { ForwardRef as ReactComponent };